"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.articleFactory = void 0;
var utils_1 = require("@lglp/utils");
var constants_1 = require("../../../constants");
var field_groups_1 = require("../../../field-groups");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
var processArticle = function (prismicPage, normalizedPage, logger) {
    var _a, _b;
    var card = field_groups_1.toCard(prismicPage.data, logger) || {};
    return utils_1.compact(__assign(__assign({}, normalizedPage), { localization: logger.required(constants_1.toLocalization((_a = prismicPage.data) === null || _a === void 0 ? void 0 : _a.localization, logger)), card: __assign(__assign({}, card), { title: (card === null || card === void 0 ? void 0 : card.title) || normalizedPage.title, cta: __assign(__assign({}, (card.cta || {})), { link: logger.required(fields_1.toDocumentLink(prismicPage, logger)) }) }), body: slices_1.toSlices((_b = prismicPage.data) === null || _b === void 0 ? void 0 : _b.body_slices, logger) }));
};
var articleFactory = function (type, next) {
    return page_factory_1.pageFactory(type, function (prismicPage, normalizedPage, logger) {
        var normalizedArticle = processArticle(prismicPage, normalizedPage, logger);
        return next(prismicPage, normalizedArticle, logger);
    });
};
exports.articleFactory = articleFactory;
//# sourceMappingURL=article-factory.js.map